import { useTranslation } from "react-i18next";
import type { MqttMeterReading } from "@/api/reseller/types";
import { Badge } from "@/components/ui/badge";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";

type Props = {
	status: MqttMeterReading["status"];
};

const VARIANT_MAP: Record<
	MqttMeterReading["status"],
	"success" | "destructive" | "warning" | "info"
> = {
	completed: "success",
	error: "destructive",
	no_communication: "warning",
	request_sent: "info",
};

const LABEL_KEY_MAP: Record<MqttMeterReading["status"], string> = {
	completed: "readingDetail.statusCompleted",
	error: "readingDetail.statusError",
	no_communication: "readingDetail.statusNoCommunication",
	request_sent: "readingDetail.statusRequestSent",
};

const TOOLTIP_KEY_MAP: Record<MqttMeterReading["status"], string> = {
	completed: "readingDetail.statusCompletedTooltip",
	error: "readingDetail.statusErrorTooltip",
	no_communication: "readingDetail.statusNoCommunicationTooltip",
	request_sent: "readingDetail.statusRequestSentTooltip",
};

export function ReadingStatusBadge({ status }: Props) {
	const { t } = useTranslation();

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Badge variant={VARIANT_MAP[status]}>{t(LABEL_KEY_MAP[status])}</Badge>
			</TooltipTrigger>
			<TooltipContent>{t(TOOLTIP_KEY_MAP[status])}</TooltipContent>
		</Tooltip>
	);
}
